import type { CookieConsentConfig } from 'vanilla-cookieconsent';
import { AppRoutes } from '@app/core/routing';

// Banner themed from DaisyUI/brand tokens. Applied as inline styles on #cc-main
// so they outrank the library stylesheet, which declares its defaults there.
// Font inherits the body (Manrope); --font-sans resolves to Epilogue at runtime.
const cookieConsentTheme: Record<string, string> = {
  '--cc-font-family': 'inherit',
  '--cc-bg': 'var(--color-base-100)',
  '--cc-primary-color': 'var(--color-base-content)',
  '--cc-secondary-color': 'color-mix(in oklab, var(--color-base-content) 70%, transparent)',
  '--cc-modal-border-radius': 'var(--radius-box)',
  '--cc-btn-border-radius': 'var(--radius-button)',
  '--cc-btn-primary-bg': 'var(--color-primary)',
  '--cc-btn-primary-color': 'var(--color-primary-content)',
  '--cc-btn-primary-border-color': 'var(--color-primary)',
  '--cc-btn-primary-hover-bg': 'color-mix(in oklab, var(--color-primary) 85%, black)',
  '--cc-btn-primary-hover-color': 'var(--color-primary-content)',
  '--cc-btn-primary-hover-border-color': 'color-mix(in oklab, var(--color-primary) 85%, black)',
  '--cc-btn-secondary-bg': 'transparent',
  '--cc-btn-secondary-color': 'var(--color-base-content)',
  '--cc-btn-secondary-border-color': 'var(--color-base-300)',
  '--cc-btn-secondary-hover-bg': 'var(--color-base-200)',
  '--cc-btn-secondary-hover-color': 'var(--color-base-content)',
  '--cc-btn-secondary-hover-border-color': 'var(--color-base-300)',
};

// Banner-only: a single read-only category, so nothing is gated on the choice.
// cookie.domain is left to the library default (current hostname) so the
// choice persists on every environment host.
export const cookieConsentConfig: CookieConsentConfig = {
  // onModalShow, not onModalReady: the modal is only attached to #cc-main once shown.
  onModalShow: () => {
    const container = document.getElementById('cc-main');
    for (const [property, value] of Object.entries(cookieConsentTheme)) {
      container?.style.setProperty(property, value);
    }
  },
  guiOptions: {
    consentModal: { layout: 'box inline', position: 'bottom right', equalWeightButtons: false },
  },
  categories: {
    necessary: { enabled: true, readOnly: true },
  },
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'Cookies help us do more good 🍪',
          description: `GiveBrite uses cookies to keep your donations secure, remember your preferences and understand how our site is used, so more of every donation reaches the causes you care about. <a href="${AppRoutes.page.privacy()}">Learn more</a>`,
          acceptAllBtn: 'Accept cookies',
          acceptNecessaryBtn: 'No thanks',
        },
        preferencesModal: { sections: [] },
      },
    },
  },
};
